import { ErrorEvent, EventHint } from '@sentry/react';
import { AxiosError } from 'axios';
import { AjaxError } from 'rxjs/ajax';
import { HttpError } from '@rossum/api-client/errors';

const getRequestIdFromError = (error: unknown): string | null => {
  if (error instanceof HttpError) {
    const requestId = error.headers?.['x-request-id'];
    return typeof requestId === 'string' ? requestId : null;
  }

  if (error instanceof AjaxError) {
    return error.xhr?.getResponseHeader('x-request-id') ?? null;
  }

  if (error instanceof AxiosError) {
    const requestId = error.response?.headers?.['x-request-id'];
    return typeof requestId === 'string' ? requestId : null;
  }

  return null;
};

export const withRequestId = ([event, hint]: [ErrorEvent, EventHint]): [
  ErrorEvent,
  EventHint,
] => {
  const { originalException } = hint;

  const requestId = getRequestIdFromError(originalException);

  if (requestId) {
    return [
      {
        ...event,
        tags: {
          ...event.tags,
          requestId,
        },
      },
      hint,
    ];
  }

  return [event, hint];
};
